import { Route } from "react-router-dom"
import { BulkEditForm } from "./components/driver/bulk-edit-driver-page"

export default [<Route exact path="/drivers/bulk" component={BulkEditForm} />]
